import { Flex, FlexProps, Text, Icon, IconProps } from "@chakra-ui/react";
import EtherAmount from "components/EtherAmount";
import HoneyIcon from "components/HoneyIcon";
import { BigNumber } from "ethers";

type HoneyAmountProps = FlexProps & {
  amount: BigNumber;
  iconColor?: IconProps["color"];
  iconSize?: IconProps["w"];
};

const HoneyAmount = ({
  amount,
  iconColor,
  iconSize,
  ...rest
}: HoneyAmountProps) => (
  <Flex align="center" gap="1" flex="none" {...rest}>
    <Icon as={HoneyIcon} color={iconColor} w={iconSize} h={iconSize} />
    <Text>
      <EtherAmount amount={amount} />
    </Text>
  </Flex>
);

export default HoneyAmount;
